import React, { useEffect, useState } from 'react';
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import Home from './pages/Home';
import ScrollToTop from './components/ScrollToTop';
import ArrowTop from './components/ArrowTop';
import KdramaDetailPage from './pages/KdramaDetailPage';
import KdramaCreditsList from './pages/KdramaCreditsList';
import KdramaCreditsDetails from './pages/KdramaCreditsDetails';
import Register from './pages/Register';
import Login from './pages/Login';
import MyList from './pages/MyList';
import Profil from './pages/Profil';
import { auth } from './firebaseConfig';  // Assurez-vous d'importer Firebase auth
import { onAuthStateChanged } from 'firebase/auth';
import { UserProvider } from './context/UserContext';
import ConditionsPage from './pages/ConditionsPage';
import ConfidentialitePage from './pages/ConfidentialitePage';
import FaqPage from './pages/FaqPage';
import FormPage from './pages/FormPage';

function App() {
  const [user, setUser] = useState(null);

  // Écoute les changements d'état de l'utilisateur
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
    });

    return () => unsubscribe();  // Nettoyer le listener lorsque le composant est démonté
  }, []);

  // Fonction de protection pour rediriger les utilisateurs connectés
  const RedirectIfAuthenticated = ({ children }) => {
    return user ? <Navigate to="/" /> : children;
  };
  // Fonction pour protéger certaines routes
  const PrivateRoute = ({ children }) => {
    return user ? children : <Navigate to="/login" />;
  };

  return (
    <UserProvider>
      <BrowserRouter>
        <ScrollToTop />
        <ArrowTop />
        <Routes>
          <Route path='/' element={<Home />} />
          <Route path='/kdrama/:id' element={<KdramaDetailPage />} />
          <Route path='/actor/:id/:name' element={<KdramaCreditsDetails />} />
          <Route path='/credits/:id' element={<KdramaCreditsList />} />
          <Route path='/mylist' element={<PrivateRoute><MyList /> </PrivateRoute>} />
          <Route path='/profile' element={<PrivateRoute><Profil /></PrivateRoute>} />
          <Route path='/conditions-dutilisation' element={<ConditionsPage />} />
          <Route path='/politique-de-confidentialite' element={<ConfidentialitePage />} />
          <Route path='/faq' element={<FaqPage />} />
          <Route path='/contact' element={<FormPage />} />
          {/* Routes protégées : Si l'utilisateur est déjà connecté, on redirige vers la page d'accueil */}
          <Route
            path='/login'
            element={
              <RedirectIfAuthenticated>
                <Login />
              </RedirectIfAuthenticated>
            }
          />
          <Route
            path='/register'
            element={
              <RedirectIfAuthenticated>
                <Register />
              </RedirectIfAuthenticated>
            }
          />


          {/* Route pour les pages non trouvées */}
          <Route path='*' element={<Home />} />
        </Routes>
      </BrowserRouter>
    </UserProvider>
  );
}

export default App;
